<template>
    <div>
        <!-- Create Items Screen -->
        <div>
            <div v-if="collapse">
                <p class="btn btn-fill btn-twitter" @click="collapse = false">
                    Ekle
                </p>
            </div>
            <div v-else ref="panel" class="form-group card p-3">
                <div>
                    <label class="col-form-label"
                        >Baslik
                        <span style="color: gainsboro;">(*)</span></label
                    >
                    <i18n-text
                        :name="'visiting-point-title'"
                        :value="newVisitingPoint.title"
                        :create-hidden-input="false"
                    ></i18n-text>
                </div>
                <div class="py-2">
                    <label class="col-form-label"
                        >Resim <span style="color: gainsboro;">(*)</span></label
                    >
                    <div class="input-group">
                        <div
                            class="d-flex"
                            style="align-items: center; gap: 10px"
                        >
                            <label for="files" class="btn btn-default"
                                >Resim ekle</label
                            >
                            <img
                                style="width: 100px;"
                                id="upload-file-info"
                                readonly
                                v-if="
                                    newVisitingPoint.image &&
                                        newVisitingPoint.image.thumbnail
                                "
                                :src="
                                    `${image_service}${newVisitingPoint.image.thumbnail}`
                                "
                            />

                            <input
                                id="files"
                                type="file"
                                accept="image/png, image/jpeg, image/jpg"
                                class="btn btn-default"
                                style="visibility:hidden;"
                                @change="preview($event, 'image')"
                            />

                            <button
                                v-if="newVisitingPoint.image"
                                class="btn btn-danger btn-sm"
                                type="button"
                                @click="deleteImage($event, 'image')"
                            >
                                <i class="material-icons">close</i>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="py-2">
                    <label class="col-form-label">Görevler</label>
                    <i18n-textarea
                        :name="'visitin-point-missions'"
                        :value="newVisitingPoint.missions"
                        :create-hidden-input="false"
                    >
                    </i18n-textarea>
                </div>
                <div class="py-2">
                    <label class="col-form-label">Geojson</label>
                    <textarea
                        v-model="newVisitingPoint.geojson"
                        type="text"
                        rows="5"
                        class="form-control"
                    ></textarea>
                </div>
                <div class="py-2">
                    <label class="col-form-label">Oyunlar</label>
                    <story-visiting-point-game-select
                        :games="newVisitingPoint.games"
                        @update-games="updateGames"
                        name="visitingPointGames[]"
                    ></story-visiting-point-game-select>
                </div>
                <div class="py-2">
                    <p class="btn btn-fill btn-twitter" @click="add">
                        Ekle
                    </p>
                </div>
            </div>
        </div>
        <!-- List Items Screen -->
        <div style="padding-top: 20px;">
            <draggable
                v-model="visitingPoints"
                @start="drag = true"
                @end="drag = false"
            >
                <transition-group>
                    <div
                        v-for="(visitingPoint, vKey) in visitingPoints"
                        :key="vKey"
                    >
                        <div
                            class="d-flex"
                            style="align-items: center; gap: 10px;"
                        >
                            <i style="cursor: move;" class="material-icons"
                                >drag_indicator</i
                            >
                            <div
                                class="d-flex"
                                style="align-items: center; gap: 10px"
                            >
                                <img
                                    v-if="
                                        visitingPoint.image &&
                                            visitingPoint.image.thumbnail
                                    "
                                    :src="
                                        `${image_service}${visitingPoint.image.thumbnail}`
                                    "
                                    style="width: 100px;"
                                />
                                <div
                                    style="font-size: 14px; font-weight: 800; justify-content: end; align-items: end; width: 200px;"
                                >
                                    {{ visitingPoint.title["tr_TR"] }}
                                </div>
                                <div
                                    class="d-flex"
                                    style="flex-wrap:wrap; gap: 5px; justify-content: end; align-items: end; width: 100px;"
                                >
                                    <span
                                        v-for="(game,
                                        gmKey) in visitingPoint.games"
                                        :key="game.id"
                                        class="label-success"
                                        >{{ game.value }}</span
                                    >
                                </div>
                            </div>
                            <div
                                class="d-flex"
                                style="align-items: center; gap:10px;"
                            >
                                <p
                                    class="btn btn-fill btn-twitter"
                                    @click="edit(vKey)"
                                >
                                    Düzenle
                                </p>
                                <p
                                    class="btn btn-fill btn-twitter"
                                    @click="remove(vKey)"
                                >
                                    Sil
                                </p>
                            </div>
                        </div>
                        <hr />

                        <vue-final-modal
                            :key="visitingPoint.id"
                            v-model="visitingPoint.showEditing"
                            classes="modal-container"
                            content-class="modal-content"
                            :click-to-close="false"
                            :esc-to-close="false"
                        >
                            <span class="modal__title">
                                <slot name="title">
                                    <div
                                        class="d-flex"
                                        style="justify-content: space-between; align-items: center;"
                                    >
                                        Güncelle

                                        <button
                                            class="btn btn-primary btn-md"
                                            type="button"
                                            @click="
                                                closeEditingModal(visitingPoint)
                                            "
                                        >
                                            Kaydet<i class="material-icons"
                                                >update</i
                                            >
                                        </button>
                                    </div>
                                </slot>
                            </span>

                            <div class="modal__content">
                                <story-visiting-point-editor
                                    :key="visitingPoints[vKey].id"
                                    :editing-visiting-points="
                                        visitingPoints[vKey]
                                    "
                                ></story-visiting-point-editor>
                            </div>
                        </vue-final-modal>
                    </div>
                </transition-group>
            </draggable>
        </div>
        <!-- Create hidden field to communicate with Laravel-->
        <div>
            <input
                type="hidden"
                name="visitingPoints"
                :value="JSON.stringify(visitingPoints)"
            />
        </div>
    </div>
</template>
<script>
import Draggable from "vuedraggable";
import storyVisitingPointGameSelect from "./story-visiting-point-game-select.vue";
import storyVisitingPointEditor from "./story-visiting-point-editor.vue";
import i18nText from "./@components/i18n-text.vue";
import i18nTextarea from "./@components/i18n-textarea.vue";
import { VueFinalModal } from "vue-final-modal";
import axios from "axios";

export default {
    components: {
        Draggable,
        VueFinalModal,
        storyVisitingPointGameSelect,
        storyVisitingPointEditor,
        i18nText,
        i18nTextarea
    },
    props: ["selected-visiting-points"],
    data() {
        return {
            newVisitingPoint: {
                title: {},
                image: null,
                missions: {},
                geojson: null,
                games: []
            },
            visitingPoints: [],
            collapse: true,
            image_service: process.env.MIX_BASE_IMAGE_SERVICE
        };
    },
    methods: {
        async add() {
            if (this.validation(this.newVisitingPoint).result) {
                alert(
                    this.validation(this.newVisitingPoint).messages.join("\n")
                );
                return;
            }

            //add id to geojson for map service
            const geojson = JSON.parse(this.newVisitingPoint.geojson);

            let isValidGeojson =
                geojson &&
                geojson.features &&
                geojson.features.length &&
                geojson.features.length > 0;

            if (!isValidGeojson) {
                alert("Yanlış Geojson formatı");
                return;
            }

            this.newVisitingPoint.geojson = JSON.stringify(geojson);
            //

            //add showEditing before insert
            let obj = JSON.parse(JSON.stringify(this.newVisitingPoint));
            obj.showEditing = false;
            //

            this.visitingPoints.push(obj);
            this.resetNewVisitingPointObj();
            this.collapse = true;
        },
        async remove(key) {
            var result = confirm(
                "Bu işlem geri alınamaz. Silmek istediğinize emin misiniz? "
            );
            if (result) {
                await axios.delete(
                    `deleteVisitingPoint/${this.visitingPoints[key].id}`
                );

                this.visitingPoints.splice(key, 1);
            }
        },
        edit(key) {
            this.visitingPoints[key].showEditing = true;
        },
        async preview(e, field) {
            const file = e.target.files[0];

            const formData = new FormData();
            formData.append("file", file);
            const options = {
                method: "POST",
                body: formData,
                headers: {
                    "X-CSRF-Token": document.querySelector(
                        'meta[name="csrf-token"]'
                    ).content
                }
            };
            let response = await fetch("/saveImageToStorage", options);
            let json = await response.json();
            this.newVisitingPoint[field] = json;
        },
        async deleteImage(e, field) {
            this.newVisitingPoint[field] = null;
        },
        updateGames(games) {
            this.newVisitingPoint.games = games;
        },
        resetNewVisitingPointObj() {
            this.newVisitingPoint.title = {};
            this.newVisitingPoint.image = null;
            this.newVisitingPoint.missions = {};
            this.newVisitingPoint.geojson = null;
            this.newVisitingPoint.games = [];
        },
        async closeEditingModal(visitingPoint) {
            if (this.validation(visitingPoint).result) {
                alert(this.validation(visitingPoint).messages.join("\n"));
                return;
            }

            // send updated data to backend
            try {
                await axios.post(`updateVisitingPoint`, visitingPoint);
            } catch (e) {}

            visitingPoint.showEditing = false;
            visitingPoint.isGeojsonChanged = false;
        },

        checkGeoJsonValid(str) {
            if (!str) return false;

            try {
                JSON.parse(str);
            } catch (e) {
                return false;
            }
            return true;
        },
        validation(visitingPoint) {
            let errorMessages = [];

            let isTitleEmpty =
                visitingPoint.title && !visitingPoint.title["tr_TR"];

            let isMissionsEmpty =
                visitingPoint.missions && !visitingPoint.missions["tr_TR"];

            if (isMissionsEmpty)
                errorMessages.push("* Görev alanı boş bırakılamaz");

            if (isTitleEmpty)
                errorMessages.push("* Başlık alanı boş bırakılamaz");

            let isImageEmpty = visitingPoint.image === null;

            if (isImageEmpty)
                errorMessages.push("* Resim alanı boş bırakılamaz.");

            let isGeoJsonNotValid = !this.checkGeoJsonValid(
                visitingPoint.geojson
            );

            if (isGeoJsonNotValid)
                errorMessages.push(
                    "* Geojson alanının doğru girildiğinden emin olunuz."
                );

            let isGamesNotValid = false;
            visitingPoint.games.forEach(game => {
                if (
                    game.key === "video-watching" &&
                    (game.url === null || game.url === "")
                ) {
                    errorMessages.push("* Video oyunu için url girilmemiş");
                    isGamesNotValid = true;
                } else if (
                    game.key === "item-verification" &&
                    game.artefacts.length === 0
                ) {
                    errorMessages.push(
                        "* Eser doğrulama için eser seçimi yapılmamış"
                    );
                    isGamesNotValid = true;
                } else if (
                    game.key === "location-verification" &&
                    (game.location === null || game.location === "")
                ) {
                    errorMessages.push(
                        "* Lokasyon doğrulama için lokasyon bilgisi girilmemiş"
                    );
                    isGamesNotValid = true;
                } else if (
                    game.key === "listen" &&
                    Object.keys(game.text).length === 0
                ) {
                    errorMessages.push("* Karakter metini girilmemiş.");
                    isGamesNotValid = true;
                } else if (
                    game.key === "listen" &&
                    (game.text.hasOwnProperty("tr_TR") === false ||
                        game.text["tr_TR"] === "")
                ) {
                    errorMessages.push(
                        "* Karakter metnine en az TR metinleri girilmeli."
                    );
                    isGamesNotValid = true;
                }
            });

            return {
                messages: errorMessages,
                result:
                    isTitleEmpty ||
                    isImageEmpty ||
                    isGamesNotValid ||
                    isGeoJsonNotValid
            };
        }
    },
    mounted() {
        this.visitingPoints = [...this.selectedVisitingPoints];

        this.visitingPoints.forEach(vp => {
            this.$set(vp, "showEditing", false);
        });
    }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
>>> .modal-container {
    display: flex;
    justify-content: center;
    align-items: center;
}
>>> .modal-content {
    position: relative;
    display: flex;
    flex-direction: column;
    max-height: 90%;
    margin: 0 1rem;
    padding: 1rem;
    border: 1px solid #e2e8f0;
    border-radius: 0.25rem;
    background: #fff;
    height: 700px;
}
>>> .modal__title {
    margin: 0 2rem 0 0;
    font-size: 1.5rem;
    font-weight: 700;
}
>>> .modal__content {
    flex-grow: 1;
    overflow-y: auto;
}
>>> .modal__action {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    padding: 1rem 0 0;
}
>>> .modal__close {
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
}

.label-success {
    color: white;
    background-color: green;
    padding: 2px 10px 2px 10px;
    border-radius: 10px;
    font-size: 12px;
    font-weight: 800;
    text-align: center;
    white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// resources/vue/story-visiting-point-creator.vue